import React from 'react';

const calculators = [
  { url: 'https://clearancecreatinina.com.br/', label: 'calculadora de clearance de creatinina', context: 'A doença renal pode alterar o equilíbrio do cálcio e da albumina.' },
  { url: 'https://aniongap.com.br/', label: 'calculadora de ânion gap', context: 'A albumina baixa também influencia a interpretação do ânion gap.' },
  { url: 'https://osmolaridade.com.br/', label: 'calculadora de osmolaridade', context: 'A osmolaridade ajuda a contextualizar alterações do equilíbrio de água e solutos.' },
  { url: 'https://sodiocorrigido.com.br/', label: 'calculadora de sódio corrigido', context: 'A glicemia pode alterar a interpretação da concentração de sódio.' },
];

export default function RelatedCalculators() {
  return (
    <section aria-labelledby="related-heading" className="related-section">
      <h2 id="related-heading">Quais outras calculadoras ajudam no contexto clínico?</h2>
      <p className="related-intro">Explore ferramentas complementares para interpretar outros parâmetros e contextos de saúde.</p>
      <ul className="related-list">
        {calculators.map(({ url, label, context }, index) => (
          <li key={url} className="related-item">
            <span className="related-index">0{index + 1}</span>
            <div>
              <a href={url}>{label}</a>
              <p>{context}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
